/**
 * Generic window traversal to find nearest window matching a predicate.
 * Traverses up the window hierarchy within same-origin boundaries.
 */
const traverseWindowHierarchy = (win, predicate) => {
  let top = win;
  if (predicate(win)) {
    return win;
  }
  while (win.parent !== win) {
    try {
      // Will throw when the parent window is from a different domain
      void win.parent.document;
      if (predicate(win.parent)) {
        return win.parent;
      }
      top = win.parent;
    } catch (e) {
      // Skip different origin frame
    }
    win = win.parent;
  }
  return top;
};

/**
 * Returns a window with 1 of two conditions
 * 1. It has a copilot channel created on it
 * 2. It is the highest level same-domain window (i.e. the highest level window
 * with the (app.hubspot.com) domain. This is the default highest layer for a
 * copilot channel.
 * @param win The window to start looking for the nearest Copilot Layer
 * @returns The highest level window in a copilot channel layer.
 */
export const findNearestWindowWithCopilotChannel = win => {
  return traverseWindowHierarchy(win, w => !!w.copilotChannel);
};
export const findNearestWindowWithInstanceOfCopilotChannel = (win, instanceId) => {
  return traverseWindowHierarchy(win, w => {
    var _w$copilotChannelInst;
    return !!((_w$copilotChannelInst = w.copilotChannelInstances) !== null && _w$copilotChannelInst !== void 0 && _w$copilotChannelInst[instanceId]);
  });
};